import styled from 'styled-components'
import { pageWrapper } from 'styles/mixins/page'

export const Wrapper = styled.div`
  ${pageWrapper(false)}
`
